import React from "react";

function ToolSideBar(props) {
  return <div className="tool-sidebar"></div>;
}

export default ToolSideBar;
